exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".basic-container {\n  padding: 10px 6px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.basic-container--block {\n    height: 100%;\n}\n.basic-container--block .el-card {\n      height: 100%;\n}\n.basic-container .el-card {\n    width: 100%;\n}\n.basic-container:first-child {\n    padding-top: 0;\n}\n", ""]);

// exports
